module.exports = __webpack_public_path__ + "img/kachel_BEWEGLICHKEIT_bodygel.be38bb7a.png";